import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionContact, ElectionContext, Round } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-poll-creation-security',
  templateUrl: 'poll-creation-security.component.html',
  styleUrls: ['./poll-creation-security.component.less', '../../../shared/common.less'],
})

export class PollCreationSecurityComponent implements OnInit {
  @Input() is2FA: boolean;
  @Input() hasPassword: boolean;
  @Input() password: string;
  @Input() phoneChangeable: boolean;
  @Output() is2FAChange = new EventEmitter<boolean>();
  @Output() phoneChangeableChange = new EventEmitter<boolean>();
  @Output() hasPasswordChange = new EventEmitter<boolean>();
  @Output() passwordChange = new EventEmitter<string>();
  needPap: boolean = undefined;

  constructor() {}
  
  onPartialChange() {
  }

  onPhoneChangeable() {
    this.phoneChangeableChange.emit(this.phoneChangeable);
  }

  on2FAChange() {
    this.is2FAChange.emit(this.is2FA);
  }

  onPasswordToggleChange() {
    this.hasPasswordChange.emit(this.hasPassword);
  }

  onPasswordChange() {
    this.passwordChange.emit(this.password);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  trackByIndex(index: number): number {
    return index;
  }

  
  ngOnInit(): void {
  }
}
